module.exports = __webpack_public_path__ + "static/Mike Chatzidakis.6949299e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Mike Chatzidakis.jpg
// module id = 1223
// module chunks = 6166952557895